import { takeLatest, put, select } from 'redux-saga/effects';

import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';
import * as availableProvidersSelfScheduling from '../requests/available-providers-self-scheduling';
import { actions as availableEirProvidersSlotsActions } from '../requests/available-eir-locations';
import {
  selectIsEirVisitTypeCode,
  selectProgramBasedVisitId,
  selectProgressOrganizationId,
  selectProgressVisitType,
  selectScheduleListReqPayload,
} from '../selectors';

function* handleStartFetchProviderList() {
  const scheduleReqPayload = yield select(selectScheduleListReqPayload);
  const organizationId = yield select(selectProgressOrganizationId);
  const visitType = yield select(selectProgressVisitType);
  const programBasedVisitId = yield select(selectProgramBasedVisitId);
  const isEirVisitType = yield select(selectIsEirVisitTypeCode);

  const baseRequestParams = {
    date: scheduleReqPayload.date,
    locationIds: scheduleReqPayload.filterIds,
    organizationId,
    reasonTypeId: scheduleReqPayload.payload.reasonTypeId,
    serviceId: scheduleReqPayload.payload.serviceId,
    userId: scheduleReqPayload.userId,
    visitTypeId: visitType.id,
  };

  if (isEirVisitType) {
    yield put(availableEirProvidersSlotsActions.send(baseRequestParams));
  } else {
    yield put(
      availableProvidersSelfScheduling.actions.send({
        ...baseRequestParams,
        pbvConfigId: programBasedVisitId,
      }),
    );
  }
}

export default function* fetchProvidersSaga() {
  yield takeLatest(
    APPOINTMENT_PROGRESS_TYPES.FETCH_PROVIDER_LIST,
    handleStartFetchProviderList,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/fetch-providers-saga.js